function manageLoginSession() {
  let totalTabs;

  // window.onload = function (e) {
  //   let accessToken = sessionStorage.getItem("token");
  //   // let accessToken = inpToken;
  //   if (accessToken !== null) {
  //     localStorage.setItem("token", accessToken);
  //     sessionStorage.removeItem("token");
  //   }
  //   if (localStorage.getItem("count") === null) {
  //     totalTabs = 0;
  //   } else {
  //     totalTabs = parseInt(localStorage.getItem("count"));
  //   }
  //   totalTabs++;
  //   localStorage.setItem("count", "" + totalTabs);
  // };

  // window.onbeforeunload = function (e) {
  //   if (localStorage.getItem("count") === null) {
  //     totalTabs = 1;
  //   } else {
  //     totalTabs = parseInt(localStorage.getItem("count"));
  //   }
  //   totalTabs--;
  //   localStorage.setItem("count", "" + totalTabs);
  //   if (totalTabs < 1) {
  //     let accessToken = localStorage.getItem("token");
  //     if (accessToken !== null) {
  //       sessionStorage.setItem("token", accessToken);
  //     }
  //     localStorage.removeItem("token");
  //     // localStorage.setItem("count", "0");
  //   }
  // };

  window.onload = (e) => {
    let accessToken = sessionStorage.getItem("token");
    if (accessToken !== null) {
      localStorage.setItem("token", accessToken);
      sessionStorage.removeItem("token");
    }
    if (localStorage.getItem("count") === null) {
      totalTabs = 0;
    } else {
      totalTabs = parseInt(localStorage.getItem("count"));

      if(totalTabs < -1) {
        totalTabs = 0;
      } 
    }
  }
}

export default manageLoginSession;